module.exports = __webpack_public_path__ + "img/Deska-Warstwowa-1.4838d467.jpg";